import { createContext, useContext } from 'react';

export type MobileLayoutContextType = {
  disableInternalScroll: boolean;
};

export const MobileLayoutContext = createContext<MobileLayoutContextType>({
  disableInternalScroll: false,
});

export const MobileLayoutProvider = ({
  children,
  disableInternalScroll,
}: {
  children: React.ReactNode;
  disableInternalScroll: boolean;
}) => {
  return <MobileLayoutContext.Provider value={{ disableInternalScroll }}>{children}</MobileLayoutContext.Provider>;
};

export const useMobileLayout = () => useContext(MobileLayoutContext);
